// capture/captureFrame.js
export function captureFrame(video, quality = 0.95) {
  const w = video.videoWidth;    // the real stream resolution
  const h = video.videoHeight;

  if (!w || !h) {
    return Promise.reject(new Error("Video dimensions not ready"));
  }

  // Downscale nothing. Canvas = source pixels.
  const canvas = document.createElement("canvas");
  canvas.width  = w;
  canvas.height = h;

  const ctx = canvas.getContext("2d", {
    alpha: false,
    desynchronized: true,        // lower latency on Chrome
    willReadFrequently: false,
  });

  // drawImage on a mirrored CSS preview still draws the raw (unmirrored) frame
  ctx.drawImage(video, 0, 0, w, h);

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => {
        if (!blob) return reject(new Error("toBlob failed"));
        if (blob.size < 131072) {
          return reject(new Error(
            `Photo is ${(blob.size / 1024).toFixed(1)} KB. ` +
            `Move closer to the camera or improve lighting.`
          ));
        }
        resolve({ blob, width: w, height: h, capturedAt: new Date() });
      },
      "image/jpeg",
      quality                     // 0.95 = near-lossless, meets 128KB easily
    );
  });
}

